import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { AuthService } from '@services/auth';

export const customerAuthGuard: CanActivateFn = (_route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    return router.createUrlTree(['/login'], {
      queryParams: { returnUrl: state.url },
    });
  }

  const user = authService.getCurrentUser();

  if (user?.type === 'customer') {
    return true;
  }

  if (user?.type === 'admin' || user?.type === 'staff') {
    return router.createUrlTree(['/admin/dashboard']);
  }

  return authService.ensureSessionFor('customer').pipe(
    map((allowed) => {
      if (allowed) {
        return true;
      }

      if (authService.getCurrentUser()?.type === 'admin' || authService.getCurrentUser()?.type === 'staff') {
        return router.createUrlTree(['/admin/dashboard']);
      }

      authService.clearSession();
      return router.createUrlTree(['/login'], {
        queryParams: { returnUrl: state.url },
      });
    }),
  );
};
